export const CURRENT_CHAIN_ID = 'current_chain_id';

export const SLIPPAGE_TOLERANCE = 'slippage_tolerance';

export const VIEW_ADDRESS = 'view_address';

